import React, { useState } from 'react';
import { Modal } from './ui/Modal';
type ModalKey = 'terms' | 'privacy' | null;
export function Footer() {
  const [active, setActive] = useState<ModalKey>(null);
  const close = () => setActive(null);
  return <>
      <footer className="w-full bg-midnight-deep py-12 px-6 border-t border-cyan-signal/10" data-id="element-22">
        <div className="max-w-6xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-23">
          <div className="font-display text-2xl text-bone uppercase tracking-widest" data-id="element-24">
            S.O.S. <span className="text-cyan-signal" data-id="element-25">Insomnio Masculino</span>
          </div>

          <p className="text-steel/60 text-sm max-w-2xl" data-id="element-26">
            Este producto no sustituye asesoramiento médico. Si sospechas apnea
            del sueño, consulta a un especialista.
          </p>

          <div className="flex gap-6 text-steel/60 text-sm" data-id="element-27">
            <button type="button" onClick={() => setActive('terms')} className="hover:text-cyan-signal transition-colors" data-id="element-28">
              Términos
            </button>
            <button type="button" onClick={() => setActive('privacy')} className="hover:text-cyan-signal transition-colors" data-id="element-29">
              Privacidad
            </button>
          </div>

          <p className="text-steel/40 text-xs mt-8" data-id="element-30">
            &copy; {new Date().getFullYear()} S.O.S. Insomnio Masculino. Todos
            los derechos reservados.
          </p>
        </div>
      </footer>

      <Modal open={active === 'terms'} onClose={close} title="Términos y Condiciones" data-id="element-31">
        <p className="text-steel/70 text-xs uppercase tracking-widest" data-id="element-32">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <div data-id="element-33">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-34">
            1. Aceptación de los Términos
          </h4>
          <p data-id="element-35">
            Al adquirir el producto digital "S.O.S. Insomnio Masculino", aceptas
            estos Términos y Condiciones en su totalidad. Si no estás de acuerdo
            con alguno de los puntos descritos, te pedimos no completar la
            compra.
          </p>
        </div>

        <div data-id="element-36">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-37">
            2. Naturaleza del Producto
          </h4>
          <p data-id="element-38">
            "S.O.S. Insomnio Masculino" es un producto educativo en formato
            digital (eBook y recursos complementarios). No es un dispositivo
            médico, ni constituye diagnóstico, tratamiento o consejo profesional
            de salud. La información provista tiene fines informativos y de
            autodesarrollo.
          </p>
        </div>

        <div data-id="element-39">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-40">
            3. Licencia de Uso
          </h4>
          <p data-id="element-41">
            Tras la compra, recibes una licencia personal, intransferible y no
            exclusiva para acceder al contenido. Queda prohibido redistribuir,
            revender, modificar o publicar el material sin autorización escrita.
          </p>
        </div>

        <div data-id="element-42">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-43">
            4. Pago y Acceso
          </h4>
          <p data-id="element-44">
            El precio mostrado es una inversión única de $27 USD. El acceso al
            contenido se entrega de forma inmediata tras la confirmación del
            pago. El acceso es por tiempo indefinido salvo cambios técnicos de
            plataforma debidamente notificados.
          </p>
        </div>

        <div data-id="element-45">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-46">
            5. Garantía de Satisfacción
          </h4>
          <p data-id="element-47">
            Ofrecemos una garantía de satisfacción durante los primeros días
            posteriores a la compra. Si el contenido no cumple con tus
            expectativas, puedes solicitar un reembolso conforme a la política
            vigente al momento de la compra.
          </p>
        </div>

        <div data-id="element-48">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-49">
            6. Limitación de Responsabilidad
          </h4>
          <p data-id="element-50">
            Los resultados varían entre individuos y dependen del nivel de
            implementación del protocolo. No garantizamos resultados
            específicos. No nos hacemos responsables de decisiones tomadas en
            base al contenido sin la debida consulta profesional cuando sea
            pertinente.
          </p>
        </div>

        <div data-id="element-51">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-52">
            7. Propiedad Intelectual
          </h4>
          <p data-id="element-53">
            Todo el contenido —textos, gráficos, marca y materiales
            descargables— es propiedad exclusiva de S.O.S. Insomnio Masculino y
            está protegido por las leyes de derechos de autor aplicables.
          </p>
        </div>

        <div data-id="element-54">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-55">
            8. Modificaciones
          </h4>
          <p data-id="element-56">
            Nos reservamos el derecho de actualizar estos términos en cualquier
            momento. La versión vigente será siempre la publicada en esta
            página.
          </p>
        </div>
      </Modal>

      <Modal open={active === 'privacy'} onClose={close} title="Aviso de Privacidad" data-id="element-57">
        <p className="text-steel/70 text-xs uppercase tracking-widest" data-id="element-58">
          Última actualización:{' '}
          {new Date().toLocaleDateString('es-ES', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        })}
        </p>

        <div data-id="element-59">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-60">
            1. Datos que Recopilamos
          </h4>
          <p data-id="element-61">
            Recopilamos únicamente la información necesaria para procesar tu
            compra y entregar el producto: nombre, correo electrónico y datos de
            pago procesados por nuestra pasarela segura.
          </p>
        </div>

        <div data-id="element-62">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-63">
            2. Uso de la Información
          </h4>
          <p data-id="element-64">
            Tus datos se utilizan exclusivamente para: confirmar el pago,
            entregar el acceso al producto, enviar comunicaciones relacionadas
            con la compra y cumplir con obligaciones legales.
          </p>
        </div>

        <div data-id="element-65">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-66">
            3. Seguridad del Pago
          </h4>
          <p data-id="element-67">
            Todos los pagos se procesan mediante pasarelas certificadas con
            cifrado SSL. No almacenamos información completa de tarjetas de
            crédito o débito en nuestros servidores.
          </p>
        </div>

        <div data-id="element-68">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-69">
            4. Compartir Información
          </h4>
          <p data-id="element-70">
            No vendemos, alquilamos ni compartimos tu información personal con
            terceros, salvo proveedores estrictamente necesarios para la
            operación (procesador de pagos, plataforma de entrega de contenido).
          </p>
        </div>

        <div data-id="element-71">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-72">
            5. Cookies
          </h4>
          <p data-id="element-73">
            Utilizamos cookies técnicas para garantizar el correcto
            funcionamiento del sitio y cookies analíticas anónimas para entender
            el comportamiento agregado de los visitantes.
          </p>
        </div>

        <div data-id="element-74">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-75">
            6. Tus Derechos
          </h4>
          <p data-id="element-76">
            Tienes derecho a acceder, rectificar o solicitar la eliminación de
            tus datos personales en cualquier momento, conforme a la legislación
            aplicable en materia de protección de datos.
          </p>
        </div>

        <div data-id="element-77">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-78">
            7. Conservación de Datos
          </h4>
          <p data-id="element-79">
            Conservamos tus datos únicamente el tiempo necesario para cumplir
            con las finalidades descritas y las obligaciones legales de
            facturación y respaldo.
          </p>
        </div>

        <div data-id="element-80">
          <h4 className="font-bold text-bone uppercase tracking-wide text-sm mb-2" data-id="element-81">
            8. Cambios a este Aviso
          </h4>
          <p data-id="element-82">
            Cualquier actualización de este Aviso de Privacidad será publicada
            en esta misma sección, con su fecha de modificación correspondiente.
          </p>
        </div>
      </Modal>
    </>;
}